import React, { Suspense, useMemo } from "react";
import type { Instance } from "../types";

const InstanceComparison = React.lazy(
  () => import("../../InstanceComparision/InstanceComparision")
);

interface ComparisonRowProps {
  isOpen: boolean;
  instance: Instance;
  originalInstance?: Instance;
  similarData?: Array<{
    provider: string;
    items: any[];
  }>;
  selectedInstance?: Instance;
  onInstanceSelect?: (instance: Instance) => void;
}

const ComparisonRow: React.FC<ComparisonRowProps> = ({
  isOpen,
  instance,
  originalInstance,
  similarData = [],
  selectedInstance,
  onInstanceSelect,
}) => {
  if (!isOpen) return null;

  // ✅ Map table instance to comparison instance type
  const comparisonInstance = useMemo(
    () => ({
      instanceType: instance.instanceType,
      instanceFamily: instance.instanceFamily,
      vcpus: instance.vcpus,
      memory: instance.memory,
      cpuArchitecture: instance.cpuArchitecture,
      awsPrice: typeof instance.aws === "number" ? instance.aws : undefined,
      gcpPrice: typeof instance.gcp === "number" ? instance.gcp : undefined,
      azurePrice:
        typeof instance.azure === "number" ? instance.azure : undefined,
      best: instance.best,
    }),
    [instance]
  );

  return (
    <tr>
      <td colSpan={11} className="bg-gray-50 p-4">
        <div className="relative border border-gray-200 rounded-lg bg-white shadow-md p-4">
          <Suspense fallback={<div className="p-4">Loading comparison...</div>}>
            <InstanceComparison
              instance={comparisonInstance as any}
              originalInstance={originalInstance}
              similarData={similarData}
              selectedInstance={selectedInstance}
              onInstanceSelect={onInstanceSelect}
            />
          </Suspense>
        </div>
      </td>
    </tr>
  );
};

export default ComparisonRow;
